import { createTheme } from '@mui/material';
import { createEliceTheme } from '@elice/mui-system';
import { AIDTBreakpoints } from '../breakpoints';
import { common } from '../tokens';
import { createAIDTTypography } from '../typography/typography';
import { basePalette } from './_base';
import { getThemeColors } from './AIDTTheme';
import { gray } from '../tokens';

import type { CreateAIDTThemeProps } from '../types/theme.types';

const createAIDTTheme = ({
  paletteMode = 'light',
  palettePublisher = 'elice',
  paletteSubject = 'korean',
  paletteLevel = 'elementary',
  typographyType = 'Default',
  typographyFontFamily = 'pretendard',
}: CreateAIDTThemeProps) => {
  const themeColors = getThemeColors(
    palettePublisher,
    paletteSubject,
    paletteLevel
  );
  return createTheme({
    ...basePalette,
    palette: {
      mode: paletteMode,
      primary: {
        main: themeColors.primary,
        dark: themeColors.black,
        light: themeColors.light,
      },
      secondary: { main: themeColors.secondary },
      background: { default: themeColors.background },
      common: common,
      grey: gray,
    },
    breakpoints: AIDTBreakpoints,
    typography: createAIDTTypography(typographyFontFamily, typographyType),
    components: {
      MuiCssBaseline: {
        styleOverrides: {
          ':root': {
            '--step--1': 'clamp(18px, 15.508px + 0.2595vw + 0.0865vh, 28.8px)',
            '--step-0': 'clamp(16.4px, 11.877px + 0.471vw + 0.157vh, 36px)',
            '--step-1': 'clamp(14.5px, 7.462px + 0.7335vw + 0.2445vh, 45px)',
            '--step-2': 'clamp(12.1px, 1.969px + 1.05525vw + 0.35175vh, 56px)',
            '--step-3': 'clamp(9px, -5.077px + 1.46625vw + 0.48875vh, 70px)',
            '--step-4': 'clamp(5px, -14.385px + 2.019vw + 0.673vh, 89px)',
          },
        },
      },
    },
  });
};

export { createAIDTTheme };
